import { FAST_API_URL, postOptions } from "../../../../../api";

export interface ReleaseResult {
    /** Заявки правок папки, что ждали выкладки и ушли сейчас; ждущих нет — пусто. */
    released: string[];
    job_id?: string | null;
    settle_until?: string | null;
}

export class ReleaseError extends Error {
    constructor(
        message: string,
        public status: number,
    ) {
        super(message);
    }
}

/**
 * «Отпустить папку» (CONTRACTS п.15): ждущие правки папки уходят в эфир сразу, без 15 с ожидания.
 * translate-python `POST /stream_editor/v1/release` → site_server `fixes/release`. Один вызов на всё:
 * смену папки в редакторе и кнопку «Готово — в эфир».
 */
export const releaseFolder = async (mediaId: string, folder: number, lang: string): Promise<ReleaseResult> => {
    const response = await fetch(`${FAST_API_URL}/release?media=${encodeURIComponent(mediaId)}`, {
        ...postOptions,
        body: JSON.stringify({ folder_num: folder, lang }),
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) {
        const detail = body?.detail;
        throw new ReleaseError(
            (detail && (detail.message || (typeof detail === "string" ? detail : ""))) ||
                `сервер ответил ${response.status}`,
            response.status,
        );
    }
    return {
        released: Array.isArray(body?.released) ? body.released.map(String) : [],
        job_id: body?.job_id ?? null,
        settle_until: body?.settle_until ?? null,
    };
};
